import type { UniversalAttributeResponse } from 'flow/store/engine/types';
import { ERROR_ATTRIBUTE_SELECTOR_PREFIX } from '~/dashboard/views/workflows/service/services/constants';
import type { CustomerService, EnabledAttribute } from './types';

export const isServiceAttribute = (attribute: Pick<EnabledAttribute, 'service_id'>): boolean => Boolean(attribute?.service_id);

export const buildAttributeLabel = (
  attribute: Pick<EnabledAttribute, 'service_id' | 'service_name' | 'display_name'>,
  service?: CustomerService,
): string => {
  const serviceName = isServiceAttribute(attribute)
    ? attribute?.service_name
    : service?.name ?? attribute?.service_name;

  return [serviceName, attribute?.display_name].filter(Boolean).join(' - ');
};

export const formatErrorAttributes = (
  universalAttributes: UniversalAttributeResponse[] = [],
): EnabledAttribute[] => {
  const errorAttributes = universalAttributes.filter(
    attribute => attribute.selector?.startsWith(ERROR_ATTRIBUTE_SELECTOR_PREFIX),
  );

  return errorAttributes.map(attribute => ({
    attribute_id: attribute.attribute_id,
    data_type: attribute.data_type,
    default: typeof attribute.default === 'string' || typeof attribute.default === 'number'
      ? attribute.default
      : false,
    name: attribute.display_name,
    display_name: attribute.display_name,
  }));
};

export const generateToken = (size: number) => {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const array: string[] = [];
  for (let index = 0; index < size; index += 1) {
    array.push(chars.charAt(Math.floor(Math.random() * chars.length)));
  }
  return array.join('');
};
